import { createLucideIcon } from "lucide-react";

export const LinkSquare = createLucideIcon(
    "LinkSquare",
    [
        [
            "path",
            {
                d: "M10.4708 12.4685C10.1773 12.7607 10.1763 13.2356 10.4685 13.5292C10.7607 13.8227 11.2356 13.8237 11.5292 13.5315L10.4708 12.4685Z",
                key: "2p16ml",
            },
        ],
        [
            "path",
            {
                d: "M11.1002 3C7.45057 3.00657 5.53942 3.09617 4.31806 4.31754C3 5.63559 3 7.75698 3 11.9997C3 16.2425 3 18.3639 4.31806 19.6819C5.63611 21 7.7575 21 12.0003 21C16.243 21 18.3644 21 19.6825 19.6819C20.9038 18.4606 20.9934 16.5494 21 12.8998",
                key: "2fj3oa",
            },
        ],
        [
            "path",
            {
                d: "M15.9999 2.25C15.5857 2.25 15.25 2.5859 15.25 3.0001C15.2501 3.4143 15.5859 3.75 16.0001 3.75L15.9999 2.25Z",
                key: "1a2i2g",
            },
        ],
        [
            "path",
            {
                d: "M20.0285 3.2271L19.8977 3.9656C19.9482 3.9745 19.9757 3.9934 19.9911 4.0089C20.0065 4.0243 20.0255 4.0518 20.0344 4.1024L20.773 3.9718L21.5115 3.8411C21.3874 3.1397 20.8609 2.6128 20.1593 2.4886L20.0285 3.2271Z",
                key: "1hy7ro",
            },
        ],
        [
            "path",
            {
                d: "M20.0285 3.2271L19.8977 3.9656L20.0285 3.2271Z",
                key: "wbsrvf",
            },
        ],
        [
            "path",
            {
                d: "M20.0285 3.2271L20.1593 2.4886C19.4584 2.3644 18.4016 2.307 17.5581 2.2787C17.1282 2.2643 16.7396 2.2572 16.4585 2.2536C16.3179 2.2518 16.2038 2.2509 16.1247 2.2505C16.0851 2.2502 16.0543 2.2501 16.0331 2.2501C16.0226 2.25 16.0144 2.25 16.0089 2.25C16.0061 2.25 16.0039 2.25 16.0024 2.25C16.0017 2.25 16.0011 2.25 16.0007 2.25C16.0005 2.25 16.0003 2.25 16.0002 2.25C16.0001 2.25 16.0001 2.25 16 2.25C16 2.25 15.9999 2.25 16 3C16.0001 3.75 16.0001 3.75 16.0001 3.75C16.0001 3.75 16.0001 3.75 16.0001 3.75C16.0001 3.75 16.0002 3.75 16.0003 3.75C16.0006 3.75 16.001 3.75 16.0016 3.75C16.0027 3.75 16.0046 3.75 16.007 3.75C16.0119 3.75 16.0193 3.75 16.0292 3.7501C16.0489 3.7501 16.0782 3.7502 16.1162 3.7504C16.1922 3.7509 16.3027 3.7517 16.4394 3.7535C16.7131 3.7569 17.091 3.7639 17.5079 3.7779C18.3577 3.8063 19.3151 3.8624 19.8977 3.9656L20.0285 3.2271Z",
                key: "1pdnx5",
            },
        ],
        [
            "path",
            {
                d: "M20.25 8C20.25 8.4142 20.5858 8.75 21 8.75C21.4142 8.75 21.75 8.4142 21.75 8H20.25Z",
                key: "13ofeo",
            },
        ],
        [
            "path",
            {
                d: "M20.5422 3.5L20.013 2.9685L10.4708 12.4685L11 13L11.5292 13.5315L21.0713 4.0315L20.5422 3.5Z",
                key: "1prcev",
            },
        ],
        [
            "path",
            {
                d: "M20.773 3.9718L21.5115 3.8411V3.8411L20.773 3.9718Z",
                key: "17kpll",
            },
        ],
        [
            "path",
            {
                d: "M21 8C21.75 8 21.75 8 21.75 7.9999C21.75 7.9999 21.75 7.9998 21.75 7.9998C21.75 7.9996 21.75 7.9995 21.75 7.9993C21.75 7.9988 21.75 7.9983 21.75 7.9975C21.75 7.996 21.75 7.9939 21.75 7.9911C21.75 7.9855 21.75 7.9774 21.75 7.9668C21.7499 7.9457 21.7498 7.9148 21.7496 7.8753C21.7491 7.7961 21.7482 7.6821 21.7464 7.5415C21.7428 7.2604 21.7356 6.8718 21.7212 6.442C21.6929 5.5986 21.6355 4.5419 21.5115 3.8411L20.773 3.9718L20.0344 4.1024C20.1375 4.6851 20.1936 5.6425 20.2221 6.4923C20.236 6.9091 20.243 7.287 20.2465 7.5607C20.2483 7.6974 20.2491 7.8078 20.2496 7.8838C20.2498 7.9218 20.2499 7.9512 20.25 7.9709C20.25 7.9808 20.25 7.9882 20.25 7.9931C20.25 7.9955 20.25 7.9973 20.25 7.9985C20.25 7.9991 20.25 7.9995 20.25 7.9997C20.25 7.9999 20.25 8 20.25 8C20.25 8 20.25 8 20.25 8C20.25 8 20.25 8 21 8Z",
                key: "zw84qk",
            },
        ],
        [
            "path",
            {
                d: "M21.0713 4.0315C21.3649 3.7393 21.3659 3.2644 21.0737 2.9709C20.7814 2.6773 20.3066 2.6763 20.013 2.9685L21.0713 4.0315Z",
                key: "b2zxuf",
            },
        ],
    ],
);
